import { getExamRegistrationField } from "./studentEnrollmentConstants";

/**
 * Build StudentReg request body (JSON or FormData entries) from form values.
 * @param {object} values form state
 * @param {object} options
 */
export function buildStudentRegPayload(values, options = {}) {
    const {
        adminID,
        role = "Student",
        selectedClass = null,
        showResidenceSection = false,
        showGuardianSection = true,
        isUniversity = false,
        enrollmentSource,
        submittedByTeacherId,
        photoFile = null,
    } = options;

    const examRegistrationField = getExamRegistrationField(selectedClass);
    const educationLevel = selectedClass?.educationLevel || "";
    const rollFromForm = Number(values.rollNum);

    const payload = {
        name: values.name?.trim(),
        password: values.password,
        sclassName: values.sclassName,
        adminID,
        role,
        photoUrl: photoFile ? "" : (values.photoUrl || "").trim(),
        gender: values.gender || undefined,
        dateOfBirth: values.dateOfBirth || undefined,
        nationality: (values.nationality || "").trim() || "Malawian",
        district: values.district || undefined,
        admissionDate: values.admissionDate || undefined,
        admissionStatus: values.admissionStatus,
        educationLevel: educationLevel || undefined,
        guardianName: showGuardianSection ? values.guardianName?.trim() : undefined,
        guardianPhone: showGuardianSection ? values.guardianPhone?.trim() : undefined,
        guardianRelation: showGuardianSection ? values.guardianRelation?.trim() : undefined,
        secondaryGuardianPhone: showGuardianSection ? values.secondaryGuardianPhone?.trim() : undefined,
        studentPhone: showGuardianSection ? values.studentPhone?.trim() : undefined,
        guardianEmail: showGuardianSection ? values.guardianEmail?.trim() : undefined,
        pslceRegNumber:
            examRegistrationField?.key === "pslceRegNumber" ? values.pslceRegNumber?.trim() : undefined,
        jceRegNumber:
            examRegistrationField?.key === "jceRegNumber" ? values.jceRegNumber?.trim() : undefined,
        msceRegNumber:
            examRegistrationField?.key === "msceRegNumber" ? values.msceRegNumber?.trim() : undefined,
        studentRegNumber: isUniversity ? values.studentRegNumber?.trim() : undefined,
        programme: isUniversity ? values.programme?.trim() : undefined,
        faculty: isUniversity ? values.faculty?.trim() : undefined,
        department: isUniversity ? values.department?.trim() : undefined,
        yearOfStudy: isUniversity ? values.yearOfStudy : undefined,
        gpa: isUniversity && values.gpa !== "" ? values.gpa : undefined,
        sponsorType: isUniversity ? values.sponsorType : undefined,
        nextOfKinName: isUniversity ? values.nextOfKinName?.trim() : undefined,
        nextOfKinPhone: isUniversity ? values.nextOfKinPhone?.trim() : undefined,
        nextOfKinRelation: isUniversity ? values.nextOfKinRelation?.trim() : undefined,
        residenceType: showResidenceSection ? values.residenceType : undefined,
        hostelRoomId:
            showResidenceSection && values.residenceType === "Boarding" && values.hostelRoomId
                ? values.hostelRoomId
                : undefined,
        bedLabel:
            showResidenceSection && values.residenceType === "Boarding" ? values.bedLabel?.trim() : undefined,
    };

    if (Number.isFinite(rollFromForm) && rollFromForm > 0) {
        payload.rollNum = rollFromForm;
    }

    if (enrollmentSource) {
        payload.enrollmentSource = enrollmentSource;
    }
    if (submittedByTeacherId) {
        payload.submittedByTeacherId = submittedByTeacherId;
    }
    if (Array.isArray(options.subjectIds) && options.subjectIds.length) {
        payload.subjectIds = options.subjectIds;
    }

    return payload;
}

export async function postStudentRegistration(payload, photoFile) {
    const { getApiBaseUrl } = await import("../../config/api");
    const axios = (await import("axios")).default;
    const baseUrl = getApiBaseUrl();

    if (photoFile instanceof File) {
        const fd = new FormData();
        Object.entries(payload).forEach(([key, value]) => {
            if (value === undefined || value === null) return;
            if (Array.isArray(value)) {
                fd.append(key, JSON.stringify(value));
            } else {
                fd.append(key, String(value));
            }
        });
        fd.append("photo", photoFile, photoFile.name);
        return axios.post(`${baseUrl}/StudentReg`, fd);
    }

    return axios.post(`${baseUrl}/StudentReg`, payload, {
        headers: { "Content-Type": "application/json" },
    });
}
